import { onMounted, ref} from 'vue'

export default {
    name: "ActionResponseBox",
    props: {
        actionResponseText: {
            type: String,
            required: true
        },
        lifeTime: {
            type:Number,
            required: false,
            default: 2500
        },
        fadeDuration: {
            type:Number,
            required: false,
            default: 500
        }
    },
    setup(props){

        const visibilityStatusClass = ref(false)
        const lifeTimeMinusAnimationTime = props.lifeTime - props.fadeDuration
        
        onMounted(() => {
            
            setTimeout(()=>{
                // function that controls visibility transition
                visibilityStatusClass.value = true

            }, lifeTimeMinusAnimationTime)
       
        })

        return {
            visibilityStatusClass
        }
    }
}